import React from 'react';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function CadDeDeptoN4Add({ setOption }) {
  return (
    <div>
      <ContainerSection>
        <div>
          <WrapperInputsNewSystem>
            <InputText title="Código ou ID" id="CodigoOuID" widthPercentage="20%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputText title="Descrição" id="Descricao" widthPercentage="50%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputText title="Departamento" id="Departamento" widthPercentage="50%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions title="* Área" id="Área" optionsArray={['']} widthPercentage="50%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions title="* Divisão" id="Divisao" optionsArray={['']} widthPercentage="50%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions title="* Empresa" id="Empresa" optionsArray={['']} widthPercentage="50%" />
          </WrapperInputsNewSystem>
        </div>
      </ContainerSection>
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
      <span> {' * '} Campo de preenchimento Obrigatório</span>
    </div>
  );
}
